/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import {useI18N} from "../../hoc/withI18N";

function ProductDetailInfo({label, value}) {

    const translate = useI18N();

    if (!value) {
        return null;
    }

    return <div className={"product-details__list-item col-xs-12 col-sm-6"}>
        <span className="product-details__list-category">{translate(label)}: </span>
        <span className="product-details__list-value">{value}</span>
    </div>

}

export default ProductDetailInfo;
